import { Table } from "../models/Table";
import { TableField } from "../models/TableField";
import { TableSchema } from "../models/TableSchema";

export class TablesTypeGuardService {

    private static readonly TABLE_TYPES_THAT_SUPPORT_CHILD_TABLES = [];

    public static isTable(obj: unknown): obj is Table {
        return (
            typeof obj === 'object' &&
            obj !== null &&
            '_type' in obj &&
            typeof (obj as any)._type === 'string'
        );
    }

    public static isTableField(obj: unknown): obj is TableField {
        return (
            typeof obj === 'object' &&
            obj !== null &&
            'name' in obj &&
            'field_type' in obj &&
            typeof (obj as any).name === 'string' &&
            typeof (obj as any).field_type === 'string'
        );
    }

    public static isTableSchema(obj: unknown): obj is TableSchema {
        return (
            typeof obj === 'object' &&
            obj !== null &&
            'type' in obj &&
            'display_name' in obj &&
            'fields' in obj &&
            typeof (obj as any).type === 'string' &&
            typeof (obj as any).display_name === 'string' &&
            Array.isArray((obj as any).fields)
        );
    }

    public static hasDefinedTableSchemaUi(tableSchema: TableSchema): boolean {
        return this.isTableSchema(tableSchema)
            && tableSchema.ui != null
            && typeof tableSchema.ui === 'object'
            && Array.isArray(tableSchema.ui.field_groups)
            && tableSchema.ui.field_groups.length > 0
            && tableSchema.ui.field_groups.every(group =>
                group != null
                && typeof group === 'object'
                && Array.isArray(group.fields)
                && group.fields.length > 0
            );
    }

    public static supportsChildTables(obj: unknown): boolean {
        // any TableField with item_schema or payload_template
        // Note that we currently do not support payload_templates for tables
        return (this.isTable(obj) && this.tableTypeSupportsChildTables((obj as Table)._type))
            || (this.isPayloadTemplateTableSchema(obj)
                && this.tableTypeSupportsChildTables((obj as TableSchema).payload_template?.type));
    }

    public static isPayloadTemplateTableSchema(obj: unknown): boolean {
        return this.isTableSchema(obj) && (obj as TableSchema).payload_template != null;
    }

    public static tableTypeSupportsChildTables(tableType?: string): boolean {
        return this.TABLE_TYPES_THAT_SUPPORT_CHILD_TABLES.find(x => tableType === x) != null;
    }

    public static isNonEmptyTableObject(value: unknown): value is Record<string, unknown> {
        return (
            typeof value === 'object' &&
            value !== null &&
            !Array.isArray(value) &&
            Object.keys(value).length > 0
        )
    }
}
